export default {
      id: "video-event_yawning-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "img/icons.svg#video-event_yawning",
      toString: function () {
        return this.url;
      }
    }